































import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class OneyRates extends Vue {
    private oney: any = false;

    private mounted() {
        if (window as any) {
            this.oney = (window as any).oney;
        }
    }
}
